module.exports = __webpack_public_path__ + "static/assets/ea273a4ee1c31409c67b4f7a66dde13c.svg";